import React, { useEffect, useReducer } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { tlmGetAccountNumberEquipment } from "layouts/dashboard/apiService";
import { I18n } from "aws-amplify/utils";
import { FiberManualRecord } from "@mui/icons-material";

// Initial state for the reducer
const initialState = {
  loading: true,
  data: null,
  error: null,
};

// Reducer function to handle data fetching state
function noteDeviceReducer(state, action) {
  switch (action.type) {
    case "DATA_RECEIVED":
      return { ...state, loading: false, data: action.value, error: null };
    case "ERROR":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}

const StoreNetworkDialog = ({ open, onClose, accountNumber }) => {
  const [devicePlantState, dispatchDevicePlant] = useReducer(
    noteDeviceReducer,
    initialState
  );

  useEffect(() => {
    if (open && accountNumber) {
      // Trigger fetch only if dialog is open and accountNumber is provided
      const fetchData = async () => {
        try {
          const response = await tlmGetAccountNumberEquipment(accountNumber);
          dispatchDevicePlant({ type: "DATA_RECEIVED", value: response });
        } catch (error) {
          dispatchDevicePlant({ type: "ERROR", error });
        }
      };
      fetchData();
    }
  }, [open, accountNumber]); // Trigger useEffect when 'open' or 'accountNumber' changes

  // Function to download the data as a JSON file
  const handleDownload = () => {
    if (devicePlantState.data) {
      const dataStr = JSON.stringify(devicePlantState.data, null, 2);
      const blob = new Blob([dataStr], { type: "application/json" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "store_network_data.json"; // Set the download file name
      a.click();

      URL.revokeObjectURL(url); // Clean up the URL object
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{I18n.get("Store Network")}</DialogTitle>
      <DialogContent>
        {/* Display the label 'Original Equipment' */}
        <Typography variant="h6" gutterBottom>
          {I18n.get("Original Equipment")}
        </Typography>

        {/* Check loading state and display data or error */}
        {devicePlantState.loading ? (
          <p>{I18n.get("Loading...")}</p>
        ) : devicePlantState.error ? (
          <p>{I18n.get("Error loading data")}</p>
        ) : (
          // Render the data in a list format if available
          <List>
            {devicePlantState.data && devicePlantState.data.length > 0 ? (
              devicePlantState.data.map((item, index) => (
                <ListItem key={index}>
                  <ListItemIcon>
                    <FiberManualRecord sx={{ height: 8, width: 8 }} />
                  </ListItemIcon>
                  <ListItemText primary={item} />
                </ListItem>
              ))
            ) : (
              <p>{I18n.get("No equipment data available")}</p>
            )}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        {/* Download button */}
        <Button
          onClick={handleDownload}
          color="primary"
          disabled={!devicePlantState.data}
        >
          {I18n.get("Download")}
        </Button>
        <Button onClick={onClose} color="primary">
          {I18n.get("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StoreNetworkDialog;
